import styled from 'styled-components';

import { Button, LazyImage } from '@gbs-monorepo-packages/common';
import { colors, radii } from '@gbs-monorepo-packages/styles';

export const TextContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-size: 0.875rem;
  padding: 0 0 0.5rem;
`;

export const Title = styled.h1`
  font-size: 1.5rem;
  margin: 1.5rem auto;
`;

export const Description = styled.p`
  color: ${colors.textLight};
  font-size: 0.875rem;
  text-align: center;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const CheckboxWrapper = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 0.625rem;
  margin-top: 0.5rem;
`;

export const Checkbox = styled.input`
  accent-color: ${colors.blue400};
  cursor: pointer;
  flex-shrink: 0;
  height: 1rem;
  margin-top: 0.125rem;
  width: 1rem;
`;

export const CheckboxLabel = styled.label`
  color: ${colors.text};
  cursor: pointer;
  font-size: 0.875rem;
  line-height: 1.5;
`;

export const TermsLink = styled.a`
  color: ${colors.authPagesLink};
  font-weight: 700;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const ErrorMessage = styled.p`
  color: ${colors.red300};
  font-size: 0.875rem;
`;

export const SubmitButton = styled(Button)`
  all: unset;
  align-items: center;
  background-color: ${colors.blue400};
  border-radius: ${radii.lg};
  color: ${colors.white300};
  display: flex;
  font-size: 1rem;
  height: 2.5rem;
  justify-content: center;
  margin-top: 0.5rem;

  &:hover {
    opacity: 0.9;
  }
`;

export const LazyImageCustom = styled(LazyImage)`
  max-height: 6.875rem;
`;
